/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import { pickUpSharedLogin } from "../utils/sharedLogin";

// An expired or ended login is caught by the API (401 SESSION_ENDED, see
// Api/api.js), so here we only need to know whether someone is signed in.
export default function ProtectedRoute({ children }) {
  const [user] = useState(() => JSON.parse(secureLocalStorage.getItem("profile")));
  const navigate = useNavigate();
  const restricted = user?.results?.assets === "Restricted";

  useEffect(() => {
    if (!user) {
      // Signed in to another app already? Pick that login up instead.
      pickUpSharedLogin().then((picked) => {
        if (!picked) navigate("/assets-register/login");
      });
    }
  }, [user, navigate]);

  useEffect(() => {
    if (restricted) {
      toast.error("You are not allowed to access this system");
      navigate("/assets-register/login");
    }
  }, [restricted, navigate]);

  if (user && !restricted) return children;

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Triangle
        visible={true}
        height="80"
        width="80"
        color="#4fa94d"
        ariaLabel="triangle-loading"
      />
    </div>
  );
}
